











import { Component, Vue, Prop } from "vue-property-decorator";
import { Tabs } from "ant-design-vue";

@Component({
  name: "CTabs",
  components: {
    ATabs: Tabs,
    ATabPane: Tabs.TabPane
  }
})
export default class CTabs extends Vue {
  @Prop() labels!: string[];
  private activeIndex = 0;

  private callback(idx: number) {
    this.activeIndex = idx;
    this.$emit("click", { activeIndex: idx });
  }
}
